import { useState, useEffect } from "react";
import styles from './trips.module.css';
import { Link } from "react-router-dom";
import {API_URL} from '../../trip/utils/fatch';

export const TripsManagement = () => {


    const [trips, setTrips] = useState([]);
    const [filteredTrips, setFilteredTrips] = useState([]);
    const [filters, setFilters] = useState({
        trip_name: '',
        destination: '',
        budget_min: '',
        budget_max: '',
        travelers_min: '',
    });
    const [sortConfig, setSortConfig] = useState({
        key: 'id',
        direction: 'asc'
    });

   
    /*    const fakeUser = [
   
           {
               created_at: "2025-08-18T19:25:28.000Z",
               current_trip_id: 20,
               email: "2048yossi@gmail.com",
               email_verified: false,
               firstname: "joseph",
               id: 31,
               is_active: true,
               last_login: null,
               lastname: "goldberger",
               role: "user",
               token_expires_at: null,
               updated_at: "2025-08-18T19:25:28.000Z",
               verification_token: null
           }
   
       ] */



    async function fetchAndRenderAllData() {


        try {


            const response = await fetch(`${API_URL}/admin/allTrips`,
                {
                    method: 'GET', // Use 'POST' for login
                    credentials: 'include', // ✅ Required for cookies

                }
            );
            // console.log(budgetResponse.status);
            if (!response.ok) {
                console.log(response.status);

                return

            }
            const data = await response.json();
            console.log(data);

            setTrips(data.trips);
            setFilteredTrips(data.trips);




        } catch (error) {
            console.error("Error fetching data:", error);


        }
    }

    const applyFiltersAndSort = (tripsData, filtersData, sortData) => {
        let result = [...tripsData];

        // Apply filters
        if (filtersData.trip_name) {
            result = result.filter(trip => 
                trip.trip_name.toLowerCase().includes(filtersData.trip_name.toLowerCase())
            );
        }
        if (filtersData.destination) {
            result = result.filter(trip => 
                trip.destination.toLowerCase().includes(filtersData.destination.toLowerCase())
            );
        }
        if (filtersData.budget_min) {
            result = result.filter(trip => trip.budget >= Number(filtersData.budget_min));
        }
        if (filtersData.budget_max) {
            result = result.filter(trip => trip.budget <= Number(filtersData.budget_max));
        }
        if (filtersData.travelers_min) {
            result = result.filter(trip => trip.travelers >= Number(filtersData.travelers_min));
        }

        // Apply sort
        result.sort((a, b) => {
            const aValue = a[sortData.key];
            const bValue = b[sortData.key];

            if (typeof aValue === 'string') {
                const comparison = aValue.toLowerCase().localeCompare(bValue.toLowerCase());
                return sortData.direction === 'asc' ? comparison : -comparison;
            }

            if (sortData.direction === 'asc') {
                return aValue > bValue ? 1 : -1;
            } else {
                return aValue < bValue ? 1 : -1;
            }
        });

        return result;
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        const newFilters = { ...filters, [name]: value };
        setFilters(newFilters);
        setFilteredTrips(applyFiltersAndSort(trips, newFilters, sortConfig));
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        const newSortConfig = { key, direction };
        setSortConfig(newSortConfig);
        setFilteredTrips(applyFiltersAndSort(trips, filters, newSortConfig));
    };

    const clearFilters = () => {
        setFilters({
            trip_name: '',
            destination: '',
            budget_min: '',
            budget_max: '',
            travelers_min: '',
        });
        setFilteredTrips(trips);
    };

    useEffect(() => {
        fetchAndRenderAllData();
    }, [])
    return (<>

        {console.log(trips)}
        <main className={styles.main}>
            <div className={styles.pageHeader}>
                <Link to="/admin" className={styles.adminLink}>Go Back</Link>

                <h2 className={styles.h2}>Trips Management</h2>
                <div className={styles.adminLink} style={{ visibility: 'hidden' }}></div>

            </div>

            <div className={styles.filterSection}>
                <h3>Filters</h3>
                <div className={styles.filterGrid}>
                    <input
                        type="text"
                        name="trip_name"
                        placeholder="Filter by trip name"
                        value={filters.trip_name}
                        onChange={handleFilterChange}
                        className={styles.filterInput}
                    />
                    <input
                        type="text"
                        name="destination"
                        placeholder="Filter by destination"
                        value={filters.destination}
                        onChange={handleFilterChange}
                        className={styles.filterInput}
                    />
                    <input
                        type="number"
                        name="budget_min"
                        placeholder="Min budget"
                        value={filters.budget_min}
                        onChange={handleFilterChange}
                        className={styles.filterInput}
                    />
                    <input
                        type="number"
                        name="budget_max"
                        placeholder="Max budget"
                        value={filters.budget_max}
                        onChange={handleFilterChange}
                        className={styles.filterInput}
                    />
                    <input
                        type="number"
                        name="travelers_min"
                        placeholder="Min travelers"
                        value={filters.travelers_min}
                        onChange={handleFilterChange}
                        className={styles.filterInput}
                    />
                    <button onClick={clearFilters} className={styles.clearButton}>Clear Filters</button>
                </div>
            </div>

            <table className={styles.userTable}>
                <thead>
                    <tr>
                        <th onClick={() => handleSort('id')} className={styles.sortable}>
                            ID {sortConfig.key === 'id' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                        </th>
                        <th onClick={() => handleSort('trip_name')} className={styles.sortable}>
                            Trip Name {sortConfig.key === 'trip_name' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                        </th>
                        <th onClick={() => handleSort('destination')} className={styles.sortable}>
                            Destination {sortConfig.key === 'destination' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                        </th>
                        <th onClick={() => handleSort('start_date')} className={styles.sortable}>
                            Start&apos;s {sortConfig.key === 'start_date' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                        </th>
                        <th onClick={() => handleSort('end_date')} className={styles.sortable}>
                            End&apos;s {sortConfig.key === 'end_date' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                        </th>
                        <th onClick={() => handleSort('budget')} className={styles.sortable}>
                            Budget {sortConfig.key === 'budget' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                        </th>
                        <th onClick={() => handleSort('travelers')} className={styles.sortable}>
                            Travelers {sortConfig.key === 'travelers' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                        </th>
                        <th>Suggestions Based on Budget</th>
                        <th>Image</th>
                       
                        <th onClick={() => handleSort('user_id')} className={styles.sortable}>
                            User ID {sortConfig.key === 'user_id' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                        </th>





                    </tr>
                </thead>
                <tbody>
                    {filteredTrips.map((trip) => (
                        <tr key={trip.id}>
                            <td>{trip.id}</td>
                            <td>{trip.trip_name}</td>
                            <td>{trip.destination}</td>
                         <td>{new Date(trip.start_date).toLocaleDateString()}</td>
                            <td>{new Date(trip.end_date).toLocaleDateString()}</td>
                            <td>{trip.budget}</td>
                            <td>{trip.travelers}</td>
                            <td>{trip.suggestions_based_on_budget.toString()}</td>
                            <td><a href={trip.img}>{trip.img}</a></td>
                           
                            <td>{trip.user_id}</td>







                        </tr>
                    ))}
                </tbody>
            </table>


        </main>

    </>)
}